import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "map-attribution" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "map-attribution-text" }, "©"),
  /*#__PURE__*/_createElementVNode("a", {
    class: "map-attribution-text",
    href: "https://www.openstreetmap.org/copyright",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " OpenStreetMap ")
], -1)

import { toRefs, withDefaults } from 'vue'

  import { IWorkout } from '@/types/workouts'
  import { getApiUrl } from '@/utils'

  interface Props {
    workout: IWorkout
    displayHover?: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    workout: null,
    displayHover: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { workout: IWorkout, displayHover: boolean }

  
  const { displayHover } = toRefs(props)
  const imageUrl = `${getApiUrl()}workouts/map/${props.workout.map}`

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["static-map", { 'display-hover': _unref(displayHover) }])
  }, [
    (_unref(displayHover))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: imageUrl,
          alt: ""
        }))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "bg-map-image",
          style: _normalizeStyle({
        backgroundImage: `url(${imageUrl})`,
      })
        }, null, 4)),
    _hoisted_1
  ], 2))
}
}

})